import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/logs/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/logs/historico" });
  }
});
